/* Copyright 2011-2012 The MathWorks, Inc. */

define([
    "dojo/_base/declare",
    "dijit/_WidgetBase",
    "dijit/_TemplatedMixin",
    "dojo/text!./templates/EmptyControl.html",
    "./_WidgetMixin"
], function (declare, _WidgetBase, _TemplatedMixin, template, _WidgetMixin) {

    return declare([_WidgetBase, _TemplatedMixin, _WidgetMixin], {
        /** @lends EmptyControl# */

        /**
         * @class EmptyControl is a filler control that you can add in order to achieve certain
         * layouts. For example: you can add an empty control as a third control in a column if you
         * want the first two controls to not be centered but instead appear to be vertically
         * aligned to the top. This controls can not be interacted with nor is it visually apparent
         * to the user.
         * @extends dijit/_WidgetBase
         */

        templateString: template
    });

});